import 'rxjs/add/observable/timer';

import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { RoutesAddressFullEnum } from 'src/app/address-full/shared/enums/routes-address-enum';
import { OffersFullNavigationService } from 'src/app/offers-full/shared/offers-navigation.service';

import { Analytics } from '../../shared/analytics';
import { LatamErrorMessageService } from '../../shared/latam-error-message/latam-error-message.service';
import { AdminListEnum } from '../../shared/services/admin-lists/enum/admin-list.enum';
import { GetReadyModelFull } from '../models/get-ready-model';
import { GetReadyCommonFullService } from '../shared/get-ready-common.service';
import { GetReadyFullConstants } from '../shared/get-ready-constants';
import { GetReadyFormFullService } from '../shared/get-ready-form.service';
import { GetReadyNavigationFullService } from '../shared/get-ready-navigation.service';

@Component({
  selector: 'preparate-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingFullComponent implements OnInit, OnDestroy {
  pageId = 'loading';
  isBtnDisabled = false;
  getReadyForm: GetReadyModelFull;
  loaderIcon = true;
  buttonContinuar = false;
  percent = 0;
  cardOffers: any[];
  actualCardOffers = 0;
  timerOffers: Observable<any>;
  timerSolicitation: Observable<any>;
  subscriptionTimerOffers;
  subscriptionTimerSolicitation;
  getReadyCommonServiceSubscription: Subscription;

  mockCount = 0;
  getSolicitationCount = 0;
  getSolicitationMAX = 30;
  private hasSolicitationResponse = false;

  constructor(
    private getReadyCommonService: GetReadyCommonFullService,
    public navigationService: GetReadyNavigationFullService,
    private getReadyFormService: GetReadyFormFullService,
    private offersNavigationService: OffersFullNavigationService,
    private latamErrorMessageService: LatamErrorMessageService,
    private analyticsLib: Analytics,
    private elementRef: ElementRef
  ) {
    this.timerOffers = Observable.timer(10000, 10000);
    this.timerSolicitation = Observable.timer(3000, 3000);
  }

  ngOnInit() {
    this.cardOffers = this.convertToCardList(this.getReadyCommonService.getAdminList(AdminListEnum.ACCOUNT_BENEFITS));

    this.getReadyForm = this.getReadyFormService.getFormGetReady();

    this.subscriptionTimerOffers = this.timerOffers.subscribe(t => {
      this.nextCard();
    });

    this.startGetSolicitationLoop();

    this.analyticsLib.buildData('LoadingAnalizandoDatos', this.pageId, '7', false);
    this.analyticsLib.trackState(null, null);

    this.getReadyCommonServiceSubscription = this.getReadyCommonService.emissorEventos.subscribe(event =>
      this.handleEvent(event)
    );

    this.getReadyCommonService.scrollToTop(document);
  }

  convertToCardList(list) {
    const self = this;
    return list.map((elem, index) => ({
      id: index + 1,
      title: 'Beneficios',
      text: self.replaceAccents(elem.title) + ' ' + self.replaceAccents(elem.benefit_description),
      description: ''
    }));
  }

  replaceAccents(text) {
    return text
      .replace(/&aacute;/g, 'á')
      .replace(/&eacute;/g, 'é')
      .replace(/&iacute;/g, 'í')
      .replace(/&oacute;/g, 'ó')
      .replace(/&uacute;/g, 'ú');
  }

  startGetSolicitationLoop() {
    this.getSolicitationCount = 1;
    this.doGetSolicitation();

    this.subscriptionTimerSolicitation = this.timerSolicitation.subscribe(t => {
      if (this.getSolicitationCount < this.getSolicitationMAX) {
        if (this.hasSolicitationResponse) {
          this.hasSolicitationResponse = false;
          this.doGetSolicitation();
          this.getSolicitationCount++;
        }
      } else {
        this.destroyTimerSolicitation();
        this.navigationService.sendToPrevious();
        this.latamErrorMessageService.show();
      }
    });
  }

  handleEvent(event) {
    switch (event) {
      case GetReadyFullConstants.GET_SOLICITATION_SUCCESS: {
        this.hasSolicitationResponse = true;
        this.percent = this.getReadyCommonService.solicitationResponse.solicitation_status.progress_percentage;
        // tslint:disable-next-line: early-exit
        if (this.percent === 100) {
          this.loaderIcon = false;
          this.buttonContinuar = true;
          this.destroyTimerSolicitation();
        }
        break;
      }
      case GetReadyFullConstants.PATCH_PROSPECT_SUCCESS: {
        this.offersNavigationService.navigateTo(RoutesAddressFullEnum.ADDRESS_HOME);
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyTimerSolicitation();
    this.destroyTimerOffers();
    this.destroyGetReadyCommonServiceSubscription();
  }

  doGetSolicitation() {
    this.getReadyCommonService.getSolicitation();
  }

  doPatchProspect() {
    this.getReadyCommonService.patchProspectGetReady();
  }

  destroyTimerOffers() {
    if (this.subscriptionTimerOffers) {
      this.subscriptionTimerOffers.unsubscribe();
      this.subscriptionTimerOffers = undefined;
    }
  }

  destroyTimerSolicitation(): void {
    if (this.subscriptionTimerSolicitation) {
      this.subscriptionTimerSolicitation.unsubscribe();
      this.subscriptionTimerSolicitation = undefined;
    }
  }

  destroyGetReadyCommonServiceSubscription() {
    if (this.getReadyCommonServiceSubscription) {
      this.getReadyCommonServiceSubscription.unsubscribe();
    }
  }

  nextCard(): void {
    this.actualCardOffers++;
    if (this.actualCardOffers >= this.cardOffers.length) {
      this.actualCardOffers = 0;
    }
  }
}
